export default __webpack_public_path__ + "static/media/BLR15.8455e7d2.jpg";